export type ThemeMode = 'light' | 'dark';

/** Flows whose name contains this marker are rendered in dark theme (e.g. `one_pager_all5_blck`) */
export const DARK_FLOW_MARKER = '_blck';

export const getThemeModeByFlow = (flowType?: string | null): ThemeMode =>
  flowType?.includes(DARK_FLOW_MARKER) ? 'dark' : 'light';
